import axios from 'axios';
import get from 'lodash/get';

const hasAxiosKey = val => val && typeof val.axios === 'boolean';
const handleAxios = val => val && val.axios === true;

const axiosPromiseMiddleware = store => next => (action) => {
	const { dispatch } = store;
	if (hasAxiosKey(action) && handleAxios(action)) {
		return new Promise((res, rej) => {
			if (typeof window.__PRELOADED_STATE__ != 'undefined' && typeof window.__PRELOADED_STATE__.webp != 'undefined' && window.__PRELOADED_STATE__.webp) {
          		action.options.headers = {Accept: 'application/json,text/plain.image/webp,*/*;'};
			}
			const options = Array.isArray(action.options) ? action.options : [action.options];
			const requests = [];
			options.map((option)=>{
				if (option.method === 'get') {
					requests.push(axios.get(option.url));
				} else {
					requests.push(axios.post(option.url,option.data));
				}
			})
			axios.all(requests).then((results) => {
				let payload = {}
				results.map((result)=>{
					const data = result.data.data ? result.data.data : result.data;
					payload = Object.assign({}, payload, data);
				})
				
				const result = Object.assign({}, action, { payload: payload, axios: false, type: `${action.type}_SUCCESS`, error: false });
				res(dispatch(result));
			}).catch((error) => {
				const result = Object.assign({}, action, { payload: error, axios: false, type: `${action.type}_FAILURE`, error: true });
				res(dispatch(result));
			});
		});
	}
	return next(action);
};

export default axiosPromiseMiddleware;


// WEBPACK FOOTER //
// ../q-cars/src/redux/middleware/axiosMiddleware.js